import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

export const fetchApiData = async (apiKey, environment, endpoint) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/api/plex-data`, {
      params: {
        apiKey,
        environment,
        endpoint
      }
    });

    return response.data;
  } catch (error) {
    if (error.response) {
      return {
        error: `HTTP ${error.response.status}: ${error.response.statusText}`,
        http_code: error.response.status,
        environment
      };
    } else {
      return {
        error: 'Network error: No response received',
        http_code: 0,
        environment
      };
    }
  }
};

export const flushTestTables = async (environment) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/api/flush-test-tables`, {
      environment
    });

    return response.data;
  } catch (error) {
    if (error.response) {
      return {
        success: false,
        error: error.response.data.error || 'Flush operation failed'
      };
    } else {
      return {
        success: false,
        error: 'Network error: Could not connect to server'
      };
    }
  }
};

export const flushProductionTables = async (environment) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/api/flush-production-tables`, {
      environment
    });

    return response.data;
  } catch (error) {
    if (error.response) {
      return {
        success: false,
        error: error.response.data.error || 'Flush operation failed'
      };
    } else {
      return {
        success: false,
        error: 'Network error: Could not connect to server'
      };
    }
  }
};

export const processTicketLifecycle = async (apiData, environment, logDbOperation, apiKey) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/api/process-tickets`, {
      apiData,
      environment,
      apiKey
    });

    return response.data;
  } catch (error) {
    logDbOperation && logDbOperation('Ticket Processing Failed', {
      error: error.message,
      environment
    }, false);

    return {
      tickets: [],
      events: []
    };
  }
};

export const fetchPartDetails = async (apiKey, environment, partId) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/api/part-details`, {
      params: {
        apiKey,
        environment,
        partId
      }
    });

    return response.data;
  } catch (error) {
    if (error.response) {
      return {
        error: `HTTP ${error.response.status}: ${error.response.statusText}`,
        http_code: error.response.status,
        environment
      };
    } else {
      return {
        error: 'Network error: No response received',
        http_code: 0,
        environment
      };
    }
  }
};

export const exportTicketEvents = async (environment) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/api/export-ticket-events`, {
      params: {
        environment
      },
      responseType: 'blob',
      validateStatus: function (status) {
        // Don't throw error for any status, we'll handle it manually
        return status >= 200 && status < 600;
      }
    });

    // Check if response is an error status
    if (response.status >= 400) {
      // Try to parse error message from blob
      try {
        const text = await response.data.text();
        console.error('Server error response:', text);
        const errorData = JSON.parse(text);
        const errorMessage = errorData.error || errorData.message || `HTTP ${response.status}: ${response.statusText}`;
        console.error('Parsed error:', errorMessage);
        if (errorData.details) {
          console.error('Error details:', errorData.details);
        }
        throw new Error(errorMessage);
      } catch (parseError) {
        console.error('Failed to parse error response:', parseError);
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
    }

    // Check content type to ensure it's CSV
    const contentType = response.headers['content-type'] || '';
    if (contentType.includes('application/json')) {
      // Response is JSON error, not CSV
      const text = await response.data.text();
      const errorData = JSON.parse(text);
      throw new Error(errorData.error || 'Export failed');
    }

    // Create a blob URL and trigger download
    const blob = new Blob([response.data], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;

    const timestamp = new Date().toISOString().replace(/[:.]/g, '-').slice(0, -5);
    link.download = `${environment}_ticket_events_${timestamp}.csv`;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    // Re-throw if it's already our formatted error
    if (error.message && (error.message.includes('HTTP') || error.message.includes('Export failed') || error.message.includes('Network error'))) {
      throw error;
    }

    // Handle other errors
    if (error.response) {
      throw new Error(`HTTP ${error.response.status}: ${error.response.statusText}`);
    } else if (error.message) {
      throw error;
    } else {
      throw new Error('Network error: Could not connect to server');
    }
  }
};